// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getUserLoggedInState } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import RecommendationsAbstractor from '@tcp/core/src/services/abstractors/common/recommendations';

import constants from './CarouselTab.constants';
import { carouselTabDataFail, carouselTabDataSuccess } from './CarouselTab.actions';

export const getCategoryKeyName = (selectedCategoryData) => {
  return selectedCategoryData?.toLowerCase()?.split(' ')?.join('');
};
export function* fetchSelectedCategoryData({ payload }) {
  const { categoryId, isTabbedModule = false } = payload;
  const name = getCategoryKeyName(categoryId);
  try {
    yield put(
      carouselTabDataSuccess({
        [name]: [],
        errors: {
          [name]: null,
        },
        completed: {
          [name]: false,
        },
      })
    );
    const categoryName = categoryId?.split(' ')?.join('');
    const isUserLoggedIn = yield select(getUserLoggedInState) || false;
    const reqPayload = {
      page: 'home',
      MONETATE_ENABLED: true,
      excludedIds: '',
      isLoggedIn: isUserLoggedIn,
      categoryNameHp: categoryName,
      birthdayDepartment: '',
      isTabbedModule,
      deviceType: 'desktop',
    };
    const result = yield call(RecommendationsAbstractor.getRecommendationsData, { ...reqPayload });
    if (result?.products?.length > 0) {
      return yield put(
        carouselTabDataSuccess({
          [name]: result.products,
          errors: {
            [name]: null,
          },
          completed: {
            [name]: true,
          },
        })
      );
    }
    throw new Error();
  } catch (err) {
    return yield put(
      carouselTabDataFail({
        [name]: [],
        errors: {
          [name]: true,
        },
        completed: {
          [name]: false,
        },
      })
    );
  }
}

function* CarouselTabSaga() {
  yield takeEvery(constants.CAROUSEL_TAB_REQ, fetchSelectedCategoryData);
}

export default CarouselTabSaga;
